export const isFullStatic = true
export const staticPath = "/home/vsts/work/1/s/node_modules/.cache/nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"